/* CCCC / club collection cards, colour swatches + size range.
   Data embedded server-side (script#cccc-card-data); inserts after the
   VISIBLE card heading (this theme hides .card__information).
   Scoped to CCCC + Woodlands collections. */
(function () {
  var COLOUR_MAP = {'black':'#1a1a1a','jet black':'#0d0d0d','deep black':'#0d0d0d','white':'#ffffff','arctic white':'#ffffff','natural':'#efe7d6','ecru':'#efe7d6','cream':'#f3ead3','sand':'#d8c9a3','biscuit':'#d9c4a0','navy':'#20294a','deep navy':'#1b2440','french navy':'#1b2440','oxford navy':'#1b2440','red':'#c0202a','classic red':'#c0202a','bright red':'#d12631','burgundy':'#6d1f2e','maroon':'#5e1a2b','royal':'#1f4fb0','bright royal':'#1f4fb0','royal blue':'#1f4fb0','sapphire':'#1e63a8','sapphire blue':'#1e63a8','cobalt':'#2b50a0','azure':'#3a78c2','sky':'#7fb9e6','sky blue':'#7fb9e6','light blue':'#a9cde8','dusty blue':'#90a8c0','airforce blue':'#5a7a99','turquoise':'#2bb6c4','teal':'#1f8a8a','bottle green':'#0f3b2e','bottle':'#0f3b2e','forest':'#16432c','forest green':'#16432c','kelly':'#1f8f48','kelly green':'#1f8f48','emerald':'#1f9d6b','green':'#1f8f48','lime':'#9cc63b','lime green':'#9cc63b','olive':'#6b6a2f','khaki':'#7c734a','sage':'#9bae8e','mint':'#a9e0c6','charcoal':'#3a3a3a','dark grey':'#4a4a4a','dark heather grey':'#5a5a5a','graphite':'#4a4a4a','graphite grey':'#4a4a4a','heather grey':'#9b9b9b','heather gray':'#9b9b9b','grey':'#9b9b9b','gray':'#9b9b9b','sport grey':'#a8a8a8','light grey':'#cfcfcf','light oxford':'#cfcfcf','zinc':'#bdbdbd','silver':'#c8c8c8','ash':'#d7d7d2','heather purple':'#6a4f86','purple':'#5b3a8a','heather burgundy':'#7a3346','plum':'#5e2a4d','fuchsia':'#c43d8a','pink':'#e58fb0','classic pink':'#e58fb0','light pink':'#f1c4d4','powder rose':'#e3b7c2','rose':'#d98aa0','coral':'#f08a6d','yellow':'#f4d03f','gold':'#e3b341','sunflower':'#f4c430','orange':'#e8732a','flame':'#e0533a','chocolate':'#4b3424','brown':'#5a3d2b','caramel':'#b07a45'};
  var MAX = 8;
  function hexFor(name){
    var n = (name||'').toLowerCase().trim();
    if(COLOUR_MAP[n]) return COLOUR_MAP[n];
    for(var k in COLOUR_MAP){ if(n.indexOf(k) > -1) return COLOUR_MAP[k]; }
    return '#cbcbcb';
  }
  var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
  if(!m) return;
  var handle = m[1];
  if(handle.indexOf('coventry-classic-car-club') < 0 && handle.indexOf('woodlands-bowling-social-club') < 0) return;
  var MAP = {}, scheduled = false;
  function colours(p){ var c = (p.options||[]).filter(function(o){ return /colou?r/i.test(o.name); })[0]; return (c && c.values) ? c.values : []; }
  function sizeRange(p){
    var s = (p.options||[]).filter(function(o){ return /size/i.test(o.name); })[0];
    if(!s || !s.values || !s.values.length) return 'One size';
    var v = s.values;
    if(/year/i.test(v.join(' '))){
      var f = (v[0].match(/\d+/) || [''])[0];
      var lm = v[v.length-1].match(/\d+/g) || [''];
      return 'Age ' + f + '–' + lm[lm.length-1];
    }
    if(v.length === 1) return v[0];
    return v[0] + '–' + v[v.length-1];
  }
  function render(){
    var cards = document.querySelectorAll('.card-wrapper, .grid__item, .card');
    for(var i=0;i<cards.length;i++){
      var card = cards[i];
      if(card.querySelector('.cccc-card-meta')) continue;
      var a = card.querySelector('a[href*="/products/"]'); if(!a) continue;
      var mm = (a.getAttribute('href')||'').match(/\/products\/([^\/?#]+)/); if(!mm) continue;
      var p = MAP[mm[1]]; if(!p) continue;
      var cols = colours(p); if(!cols.length) continue;
      var wrap = document.createElement('div'); wrap.className = 'cccc-card-meta';
      wrap.style.cssText = 'margin:7px 0 2px;display:flex;flex-direction:column;gap:5px;';
      var row = document.createElement('div'); row.style.cssText = 'display:flex;flex-wrap:wrap;gap:4px;align-items:center;';
      var lim = Math.min(cols.length, MAX);
      for(var j=0;j<lim;j++){
        var hex = hexFor(cols[j]);
        var bd = /#ffffff/i.test(hex) ? '1px solid #cccccc' : '1px solid rgba(0,0,0,0.15)';
        var sw = document.createElement('span');
        sw.title = cols[j];
        sw.style.cssText = 'width:13px;height:13px;border-radius:2px;background:'+hex+';border:'+bd+';box-sizing:border-box;display:inline-block;flex:0 0 auto;';
        row.appendChild(sw);
      }
      if(cols.length > MAX){ var pl = document.createElement('span'); pl.textContent = '+' + (cols.length - MAX); pl.style.cssText = 'font-size:12px;color:#6b6b6b;'; row.appendChild(pl); }
      var line = document.createElement('div');
      line.textContent = cols.length + ' colour' + (cols.length !== 1 ? 's' : '') + ' · ' + sizeRange(p);
      line.style.cssText = 'font-size:11px;letter-spacing:0.05em;text-transform:uppercase;color:#767676;';
      wrap.appendChild(row); wrap.appendChild(line);
      var anchor = null, hs = card.querySelectorAll('.card__heading');
      for(var h=0;h<hs.length;h++){ if(hs[h].offsetParent !== null){ anchor = hs[h]; break; } }
      if(anchor && anchor.parentNode){ anchor.parentNode.insertBefore(wrap, anchor.nextSibling); }
      else { (card.querySelector('.card__content') || card).appendChild(wrap); }
    }
  }
  function schedule(){ if(scheduled) return; scheduled = true; requestAnimationFrame(function(){ scheduled = false; render(); }); }
  function boot(){
    var el = document.getElementById('cccc-card-data');
    if(el){ try{ var d = JSON.parse(el.textContent); (d.products||[]).forEach(function(p){ MAP[p.handle] = p; }); }catch(e){} }
    render();
    try{ new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true}); }catch(e){}
  }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();
